import { useEffect } from 'react';
import '../../utils/index.js';
import createContextUtilities from '../../utils/createContextUtilities/createContextUtilities.js';

const {
  Provider: FormFieldProvider,
  useContext: useFormFieldContext
} = createContextUtilities({});
const useFormFieldControl = () => {
  const context = useFormFieldContext();
  const {
    setHasControl
  } = context;
  useEffect(() => {
    setHasControl === null || setHasControl === void 0 || setHasControl(true);
  }, [setHasControl]);
  return context;
};
const useFormFieldLabel = () => {
  const context = useFormFieldContext();
  const {
    setHasLabel
  } = context;
  useEffect(() => {
    setHasLabel === null || setHasLabel === void 0 || setHasLabel(true);
  }, [setHasLabel]);
  return context;
};
const useFormFieldType = type => {
  const context = useFormFieldContext();
  const {
    setFormFieldType
  } = context;
  useEffect(() => {
    setFormFieldType === null || setFormFieldType === void 0 || setFormFieldType(type);
  }, [setFormFieldType, type]);
  return context;
};

export { FormFieldProvider, useFormFieldContext, useFormFieldControl, useFormFieldLabel, useFormFieldType };
